.steps {
  width: 100%;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: unset;
  border-bottom: 12px solid var(--paletteNeutral3);
  border-radius: unset;
  width: 100%;
  padding: 0 0 var(--spacingMd);

  &:hover {
    background: unset;
    border-bottom: 12px solid var(--palettePrimary0);
  }
}

.selected {
  border-bottom: 12px solid var(--paletteBlue0);
}
